<template>
  <li v-if="showMenu" class="nav-item btn-group">
    <a class="nav-link dropdown-toggle" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-user-circle-o"></i>{{$store.state.user.data.username}}</a>
    <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
      <router-link :to='dashboardURL' class="dropdown-item">dashboard</router-link>
      <!--router-link :to='settingsURL' class="dropdown-item">settings</router-link-->
      <Logout></Logout>
    </div>
  </li>
</template>

<script>
  import Logout from '../../User/Logout';

  export default {
    name: 'UserMenu',
    components: { Logout },
    data() {
      return {
      };
    },
    computed: {
      showMenu() {
        if (typeof this.$store.state.user.data.username !== 'undefined') {
          if (this.$store.state.user.data.username !== '') {
            return true;
          }
        }
        return false;
      },
      dashboardURL() {
        return `/${this.$store.state.language}/admin/dashboard`;
      },
    /*settingsURL() {
      if (this.$store.state.user.data.type === 'promoter') {
        return `/${this.$store.state.language}/supplier/settings`;
      }
      return `/${this.$store.state.language}/user/settings`;
    },*/
    },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// UserMenu.vue?f4bc474e